module.exports = __webpack_public_path__ + "img/HQ-ENC-C-V1_ALL.f1fd9fe8.jpg";